export default "__VITE_ASSET__Cf9AOxOa__"